export default {
  // Page title
  title: "Configuración de Inserción Automática",

  // Search form
  searchForm: {
    pushTitle: "Título de Inserción",
    pushTitlePlaceholder: "Ingrese",
    language: "Idioma",
    languagePlaceholder: "Seleccione",
    pushSwitch: "Interruptor de Inserción",
    pushSwitchPlaceholder: "Seleccione",
    search: "Buscar",
    reset: "Restablecer",
    add: "Añadir Nuevo"
  },

  // Table column titles
  table: {
    pushType: "Tipo de Inserción",
    subType: "Subtipo",
    pushTitle: "Título de Inserción",
    pushContent: "Contenido de Inserción",
    jumpPath: "Ruta de Salto",
    language: "Idioma",
    pushSwitch: "Interruptor de Inserción",
    inboxPushSwitch: "Interruptor de Mensaje de Bandeja de Entrada",
    inboxMessageType: "Tipo de Mensaje de Bandeja de Entrada",
    operation: "Operación",
    edit: "Editar",
    delete: "Eliminar"
  },

  // Push types
  pushTypes: {
    recharge: "Recarga",
    withdrawal: "Retiro",
    vipReward: "Recompensa VIP",
    activityOffer: "Oferta de Actividad",
    kyc: "KYC"
  },

  // Sub types
  subTypes: {
    onlineRecharge: "Recarga En Línea",
    manualRecharge: "Recarga Manual",
    onlineWithdrawal: "Retiro En Línea",
    manualWithdrawal: "Retiro Manual",
    upgradeBonus: "Bono de Actualización",
    retentionBonus: "Bono de Retención",
    weeklySalary: "Salario Semanal",
    monthlySalary: "Salario Mensual",
    birthdayBonus: "Bono de Cumpleaños",
    kycVerification: "Verificación de KYC",
    manualRechargePoints: "Acreditación Manual de Puntos",
    manualDeductPoints: "Deducción Manual de Puntos",
    upgradePoints: "Puntos de Actualización",
    retentionPoints: "Puntos de Retención",
    h5DailyPoints: "Puntos Diarios H5",
    appDailyPoints: "Puntos Diarios de la App",
    bettingRebate: "Reembolso de Apuestas",
    realtimeRebate: "Reembolso en Tiempo Real",
    registrationOffer: "Oferta de Registro",
    dailyFirstDeposit: "Primer Depósito Diario",
    rechargeOffer: "Oferta de Recarga",
    manualIssue: "Emisión Manual",
    everyDepositOffer: "Oferta por Cada Depósito",
    firstDepositOffer: "Oferta de Primer Depósito"
  },

  // Push switch status
  pushSwitch: {
    enabled: "Habilitado",
    disabled: "Deshabilitado"
  },

  // Modal
  modal: {
    addTitle: "Añadir Nuevo",
    editTitle: "Editar",
    pushType: "Tipo de Inserción",
    pushTypePlaceholder: "Seleccione",
    subType: "Subtipo",
    subTypePlaceholder: "Seleccione",
    notificationTitle: "Título de Notificación",
    notificationTitlePlaceholder: "Dentro de 50 caracteres",
    memberType: "Tipo de Miembro",
    memberTypePlaceholder: "Seleccione tipo de miembro",
    loginChannel: "Canal de Inicio de Sesión",
    loginChannelPlaceholder: "Seleccione",
    notificationContent: "Contenido de Notificación",
    notificationContenttips: ' (Si el contenido de inserción involucra montos u otras variables, use el formato {0})',
    notificationContentPlaceholder: "Dentro de 1000 caracteres",
    selectLanguage: "Seleccionar Idioma",
    languagePlaceholder: "Seleccione",
    jumpPath: "Ruta de Salto",
    jumpPathPlaceholder: "Ingrese ruta de salto",
    pushSwitch: "Interruptor de Inserción",
    inboxPushSwitch: "Interruptor de Inserción de Mensaje de Bandeja de Entrada",
    inboxMessageType: "Tipo de Mensaje de Bandeja de Entrada",
    inboxMessageTypePlaceholder: "Seleccione tipo de mensaje de bandeja de entrada",
    enable: "Habilitar",
    disable: "Deshabilitar",
    confirm: "Confirmar",
    cancel: "Cancelar"
  },

  // Validation messages
  validation: {
    pushTypeRequired: "Seleccione tipo de inserción",
    subTypeRequired: "Seleccione subtipo",
    notificationTitleRequired: "Ingrese título de notificación",
    notificationContentRequired: "Ingrese contenido de notificación",
    notificationContentPattern: "El contenido de notificación debe incluir formato {0-9}",
    languageRequired: "Seleccione idioma",
    inboxMessageTypeRequired: "Seleccione tipo de mensaje de bandeja de entrada"
  },

  // Envío programado (todos los miembros)
  schedule: {
    title: "Configuración de Envío Programado",
    sendDate: "Fecha de Envío Automático",
    sendDateRequired: "Seleccione la fecha de envío automático",
    dailyTime: "Hora de Envío Diario",
    dailyTimeRequired: "Seleccione la hora de envío diario",
    fillWarning: "Complete la fecha de envío automático y la hora de envío diario"
  },

  // Operation messages
  messages: {
    addSuccess: "Añadido exitosamente",
    updateSuccess: "Actualizado exitosamente",
    deleteSuccess: "Eliminado exitosamente",
    deleteFailed: "Eliminación fallida",
    fetchDataFailed: "Error al obtener datos",
    confirmDelete: "Confirmar Eliminación",
    confirmDeleteContent: "¿Está seguro de que desea eliminar la configuración de inserción \"{title}\"?"
  }
};
